// extracted by mini-css-extract-plugin
export var active = "_2c-a";
export var activeIndicator = "_2c-8";
export var animate = "_2c-9";
export var disabled = "_2c-b";
export var fullWidth = "_2c-2";
export var lg = "_2c-7";
export var md = "_2c-6";
export var redoButtonTabGroup = "_2c-0";
export var sm = "_2c-5";
export var tabButton = "_2c-3";
export var tabButtonsContainer = "_2c-1";
export var xs = "_2c-4";